import { createContext, useContext } from "react";

export interface TenantInfo {
  id: number;
  code: string;
  name: string;
}

export interface MeData {
  tenants: TenantInfo[];
  permissions: Record<string, string[]>;
  isAdmin: Record<string, boolean>;
}

interface MeContextValue {
  meData: MeData;
}

const MeContext = createContext<MeContextValue | undefined>(undefined);

export const MeContextProvider = ({
  meData,
  children,
}: {
  meData: MeData;
  children: React.ReactNode;
}) => {
  return <MeContext.Provider value={{ meData }}>{children}</MeContext.Provider>;
};

export const useMeContext = (): MeContextValue => {
  const context = useContext(MeContext);
  if (context === undefined) {
    throw new Error("useMeContext must be used within a MeContextProvider");
  }
  return context;
};
